module.exports = __webpack_public_path__ + "img/expodecor_ocean.b645edca.jpg";